import { Constants } from '@pwc/pwc-deals-web-common';
import {
  constructCompositeKey,
  deconstructAdjustmentKey,
  reconstructKeyForDdl,
} from './keyUtilities';
import { selectOrInit } from './selectors';

export const accumulateAdjustmentsFromDataRows = (
  headerRow,
  dataRows,
  configJson,
  documentCode
) =>
  dataRows.reduce((adjustmentsAccumulator, row) => {
    const financialPeriodHeaders = headerRow.slice(
      configJson.summableColumnStartIndex
    );
    const rowHeaders = row.slice(0, configJson.summableColumnStartIndex);
    const amounts = row.slice(configJson.summableColumnStartIndex);

    amounts.forEach((value, index) => {
      if (financialPeriodHeaders[index] !== '') {
        let key = constructCompositeKey(
          documentCode,
          rowHeaders,
          configJson.keyPositions,
          financialPeriodHeaders[index]
        );

        if (documentCode === Constants.DEBT_AND_DEBT_LIKE) {
          key = reconstructKeyForDdl(key);
        }

        const { shortDescription, adjustmentType, adjustmentNumber } =
          deconstructAdjustmentKey(key);

        const adjustmentTypeState = selectOrInit(
          adjustmentsAccumulator,
          adjustmentType
        );
        const adjustments = selectOrInit(
          adjustmentTypeState,
          `${adjustmentNumber} ${shortDescription}`
        );

        adjustments[key] = value;
      }
    });
    return adjustmentsAccumulator;
  }, {});
